import { useFormDisabled } from 'element-plus';
import apiClient from './post';



/**
 * 更新用户信息
 */
export function updateUserInfo(data: any) {
  return apiClient.post('/user/update', data).then(response => response.data);
}

/**
 * 获取用户的朋友列表（互相关注）
 */
export function getUserFriends(params: {
  page: number,
  pageSize: number
}) {
  return apiClient.post('/user/interaction/followees', params).then(response => response.data);
}

/**
 * 更新用户头像
 * @param avatar 头像文件
 */
export const updateUserAvatar = (avatar: File) => {
  const formData = new FormData();
  formData.append('avatar', avatar);

  return apiClient.put('/user/user/avatar', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};

/**
 * 修改用户密码
 * @param oldPassword 旧密码
 * @param newPassword 新密码
 */
export const changePassword = (oldPassword: string, newPassword: string) => {
  return apiClient.put('/user/user/password', {
    oldPassword,
    newPassword
  });
};

/**
 * 更新用户资料
 * @param profile 用户资料对象
 */
export const updateUserProfile = (profile: {
  name: string;
  email: string;
  phone: string;
  signature: string;
}) => {
  return apiClient.put('/user/user/profile', profile);
};

/**
 * 获取用户资料
 */
export const getUserProfile = () => {
  return apiClient.get('/user/user/profile');
};

/**
 * 查询其他用户信息
 * @param userId 用户ID
 */
export const getUserById = (userId: number) => {
  return apiClient.get(`/user/user/${userId}`);
};

/**
 * 获取用户粉丝列表
 * @param params 分页参数
 */
export const getUserFollowers = (params: { page: number; pageSize: number }) => {
  return apiClient.post('/user/interaction/followees', params);
};

/**
 * 获取用户关注列表
 * @param params 分页参数
 */
export const getUserFollowings = (params: { page: number; pageSize: number }) => {
  return apiClient.post('/user/interaction/followers', params);
};

/**
 * 关注/取消用户
 * @param userId 被关注的用户ID
 */
export const followUser = (userId: number) => {
  return apiClient.put(`/user/interaction/follow/${userId}`).then(response => response.data);
};


/**
 * 获取用户收藏列表
 * @param params 分页参数
 */
export const getUserFavorites = (params: { page: number; pageSize: number }) => {
  return apiClient.post('/user/interaction/list', params);
};

/**
 * 添加举报
 * @param reportData 举报数据
 */
export const addReport = (reportData: {
  targetType: number;
  targetId: number;
  reason: string;
}) => {
  return apiClient.post('/user/report/add', reportData);
};

/**
 * 获取用户发布的帖子列表
 * @param params 分页参数和状态
 */
export const getUserPosts = (params: { page: number; pageSize: number; status: number }) => {
  return apiClient.post('/user/post/my', params);
};